import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrCM: CultureInfo = {
  name: 'fr-CM',
  displayName: 'French (Cameroon)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-CM',
  parent: CultureInfoFr
};
